<template>
    <div>
        <div class="row interaction-section">
            <div class="col-md-6 interaction-main-section">
                <iframe v-if='event.trailerCode' width="560" height="315" :src="'https://www.youtube.com/embed/' + event.trailerCode + '?rel=0'" frameborder="0" allowfullscreen=""></iframe>
                
                <div v-if='event.images.length > 0' id="InteractionMainImage" >
                    <carousel :perPage='1' :autoplay='true' :autoplayTimeout='5000' :loop='true' :navigationEnabled='true' paginationPosition='bottom-overlay' paginationActiveColor='#EFEFEF' paginationColor='#888888' v-model='slideNumber'>
                        <slide v-for='image in event.images' :key='image.url'>
                            <img :src="image.url" />
                        </slide>
                    </carousel>
                </div>
                <div v-else-if='event.featuredImage' id="InteractionImage">
                    <img :src="event.featuredImage.url" />
                </div>
                
                <div id="InteractionInformation">
                    
                <h4 v-if='event.type' id='InteractionType'>{{event.type}}</h4>
                
                <h4 v-if='event.location'>{{event.location}}</h4>

                <div v-html='event.contentLeft'></div>

                
                </div>
            </div>
            <div class="col-md-6 interaction-content-section">
                <h4 v-if='event.past' class='eventClass'>Past {{event.class}} </h4>
                <div v-html='event.content'></div>

                <template v-if='event.active'>
                    <div v-if='event.bookingLink'>
                        <a :href='event.bookingLink' class='action-btn'>
                            {{bookButtonText}}
                        </a>
                    </div>
                </template>

                <div class='timeadmission' v-if='event.covidMessage' v-html='event.covidMessage'>

                </div>
                
                <div v-html='event.contentLower'></div>
            </div>
        </div>
        <div class='row'>
            <image-gallery :gallery='event.gallery' v-if='event.gallery.length > 0' carousel='true' color='cs-navy-events'>

            </image-gallery>
        </div>
        <div class='row'>
            <a name='booknow'></a>
            
            <template v-if='event.rollerCheckout != null && event.rollerCheckout != ""'>
                <iframe id="roller-widget" :src="checkoutUrl"></iframe>
            </template>
        </div>
    </div>
</template>

<style lang='less'>
.eventClass {
    border: 1px solid black;
    padding: 5px;
    text-align: center;
}

#InteractionCarousel {
    margin-top: 10px;
    img {
        padding-right: 3px;
    }
}

#InteractionType {
    margin-bottom: 0;
}

.VueCarousel .VueCarousel-navigation {
    font-size: 20px;
    color: rgb(136, 136, 136);
}

.VueCarousel .VueCarousel-navigation .VueCarousel-navigation-next {
    transform: translateY(-50%);
    color: rgba(220, 220, 220, 0.6);
}
.VueCarousel .VueCarousel-navigation .VueCarousel-navigation-prev {
    transform: translateY(-50%);
    color: rgba(220, 220, 220, 0.6);
}

.bookingTable td {
    padding:  5px 10px 5px 0;
}
</style>

<script>
import axios from 'axios';
import ImageGallery from '../components/ImageGallery'
import moment from 'moment'
import Vue from 'vue'
import { Carousel, Slide } from 'vue-carousel';
import _ from 'lodash';

export default {
    name: 'whats-on-detail',
    props: ['slug'],
    data() {
        return {
            event: {
                images:[],
                gallery:[]
            },
            slideNumber: 0,
            selectedInstance: null
        }
    },
    computed: {
        bookButtonText() {
            return this.event.bookButtonText ? this.event.bookButtonText : "Book Tickets";
        },
        hasImages() {
            return true;
        },
        selectedDate() {
            if (this.event.rollerCheckout.includes('?')) {
                return "";
            }
            if (this.selectedInstance == null) {
                return "";
            }
            let date = moment(this.selectedInstance.Date);
            
            return date.format('YYYYMMDD');
        },
        checkoutUrl() {
            let dateString = this.selectedDate == '' ? '' : `?date=${this.selectedDate}`;

            return `https://otagomuseum.checkout.roller.app/products/${this.event.rollerCheckout}${dateString}`;
        }
    },
    methods: {
        refresh() {
            axios.get(`${this.$api}/event/${this.slug}`).then(result => {
                this.event = result.data;

                this.$emit('updateHead', this.event);
            }, error => {

            });
        },
        formatDate(instance) {
            let date = moment(instance.Date);

            return date.calendar(null, {
                sameDay: 'h.mma [Today]',
                nextDay: 'h.mma [Tomorrow]',
                nextWeek: 'h.mma, dddd D MMMM',
                lastDay: '[Yesterday]',
                lastWeek: '[Last] dddd',
                sameElse: 'h.mma, dddd D MMMM '
            });
            
        },

    },
    created() {
        //this.refresh();
    },
    mounted() {
        let iframeScript = document.createElement('script');
        iframeScript.setAttribute('src', "//cdn.rollerdigital.com/scripts/widget/responsive_iframe.js");
        document.head.appendChild(iframeScript);
    },
    beforeRouteEnter (to, from, next) {
        console.log(to, from);
        axios.get(`${Vue.prototype.$api}/event/${to.params.slug}`).then(result => {
            next(vm => {
                vm.event = result.data;
                if (('instances' in result.data) && result.data.instances.length > 0) {
                     let remaining =  _.filter(result.data.instances, x=>x.CapacityRemaining > 0);

                     if (remaining.length == 0) {
                        vm.selectedInstance = result.data.instances[0];
                     } else {
                        vm.selectedInstance = remaining[0];
                     }
                     
                }
                vm.$emit('updateHead', vm.event);
            });
        }, error => {
            window.location = "/404"
        });
    },
    components: {
        'image-gallery': ImageGallery,
        Carousel,
        Slide
    }
}
</script>